import React, { useState, useRef, useEffect } from "react";
import "./style.css";

const TITLE = "Boda Lucero & Miguel";
const DESC = "¡Boda Lucero & Miguel! Día para celebrar con los novios.";
const LOCATION = "Tlajomulco de Zúñiga, Jal.";
const START_UTC = "20260919T220000Z";
const END_UTC = "20260920T070000Z";

const googleUrl =
  `https://calendar.google.com/calendar/render?action=TEMPLATE` +
  `&text=${encodeURIComponent(TITLE)}` +
  `&dates=${START_UTC}/${END_UTC}` +
  `&details=${encodeURIComponent(DESC)}` +
  `&location=${encodeURIComponent(LOCATION)}`;

const outlookUrl =
  `https://outlook.live.com/calendar/0/deeplink/compose?` +
  `subject=${encodeURIComponent(TITLE)}` +
  `&startdt=2026-09-19T17%3A00%3A00` +
  `&enddt=2026-09-20T02%3A00%3A00` +
  `&location=${encodeURIComponent(LOCATION)}` +
  `&body=${encodeURIComponent(DESC)}`;

const downloadIcs = () => {
  const content = [
    "BEGIN:VCALENDAR",
    "VERSION:2.0",
    "PRODID:-//Lucero & Miguel//Wedding//ES",
    "BEGIN:VEVENT",
    `DTSTART:${START_UTC}`,
    `DTEND:${END_UTC}`,
    `SUMMARY:${TITLE}`,
    `DESCRIPTION:${DESC}`,
    `LOCATION:${LOCATION}`,
    "END:VEVENT",
    "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([content], { type: "text/calendar;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "boda-lucero-miguel.ics";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

const CalendarButton = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  return (
    <div className="cal-wrapper" ref={ref}>
      <button className="cal-trigger" type="button" onClick={() => setOpen((v) => !v)}>
        Agregar al calendario
      </button>
      {open && (
        <div className="cal-dropdown">
          <a className="cal-option" href={googleUrl} target="_blank" rel="noreferrer">
            Google Calendar
          </a>
          <a className="cal-option" href={outlookUrl} target="_blank" rel="noreferrer">
            Outlook
          </a>
          <button className="cal-option" type="button" onClick={downloadIcs}>
            Apple · iCal
          </button>
        </div>
      )}
    </div>
  );
};

export default CalendarButton;
